import React, { Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

import withStyles from '@material-ui/core/styles/withStyles'

const styles = theme => ({
})

/**
 * Диалог вывода сообщения об ошибке
 * <ErrorMessageDialog message onClose={}/>
 */

class ErrorMessageDialog extends Component {

	render() {
		return <Dialog
			open = {Boolean(this.props.message)}
		>
			<DialogTitle>Ошибка</DialogTitle>
			<DialogContent>
				{this.props.message}
			</DialogContent>
			<DialogActions>
				<Button
					onClick={
						e => {
							e.preventDefault()
							if (typeof this.props.onClose === "function") {
								this.props.onClose()
							}
						}
					}
				>Закрыть</Button>
			</DialogActions>
		</Dialog>
	}

}

export default withStyles(styles)(ErrorMessageDialog)
